import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { FundPerformanceOverview } from '../organization-overview/utils';

@Injectable({
  providedIn: 'root',
})
export class OrganizationPageService {
  //  Fund performances are being filtered and selected to be used between org-page components.
  //  Do not confuse with hornavbar fps.
  private _fp = new BehaviorSubject<FundPerformanceOverview[]>(undefined);

  setFpOverview(fp: FundPerformanceOverview[]): void {
    this._fp.next(fp);
  }

  getFpOverview(): BehaviorSubject<FundPerformanceOverview[]> {
    return this._fp;
  }
}
